import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';
import { normalizeEquipmentTypes } from './normalize';

export const fetchEquipmentTypes = createProvider(api.fetchEquipmentTypes)
  .andThen((res) => normalizeEquipmentTypes(res))
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch list aborted');
    } else {
      console.error('Fetch list was failed:', error);
    }
    throw error;
  });
